import { render } from "./NewRowSites.vue?vue&type=template&id=70f3666b"
import script from "./NewRowSites.vue?vue&type=script&lang=js"
export * from "./NewRowSites.vue?vue&type=script&lang=js"

import exportComponent from "/builds/linkbuilding-crm/crm-v2-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__